import { render, staticRenderFns } from "./AddStaticFileDialog.vue?vue&type=template&id=cb1da0c2&"
import script from "./AddStaticFileDialog.vue?vue&type=script&lang=js&"
export * from "./AddStaticFileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports